/* default_snapshot.icon.svg.js */

module.exports = require("./thumbsup.icon.svg");
